import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicStoreCommunityZealyQuest: Story = {
  id: 'magic-store-community-zealy-quest',
  type: 'CLASSIC',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store Community Zealy Quest',
  index: 0,
  content: {
    type: ACTION_TYPES.GO_TO,
    bannerUrl: 'stories/4/main_banner.jpg',
    bannerMobileUrl: 'stories/4/main_banner_mobile.jpg',
    externalRoute: 'https://zealy.io/c/magicsquare/questboard',
    buttonText: 'Join the Community',
    title: 'Join the Magic Square Community on Zealy Now!',
    description:
      'This quest-filled adventure is a fantastic opportunity to join an engaging community, compete with fellow enthusiasts, and potentially win spectacular prizes. So, what are you waiting for? Take the leap, join our growing community on Zealy today, and start your thrilling quest with Magic Square. Remember, your growth and support fuel our journey. See you on Zealy!',
    storyBlocks: [
      {
        bannerUrl: 'stories/4/story_banner_url_1.jpg',
        title:
          'Embark on Magic Square’s Epic Quest on Zealy: A Chance to Share a Massive 1,000,000 $SQR Prize Pool',
        description:
          'Join the adventure with Magic Square on our journey towards the $SQR Token Launch, and seize the opportunity to compete for a share in the colossal 1,000,000 $SQR Token Prize Pool!',
      },
      {
        bannerUrl: 'stories/4/story_banner_url_2.jpg',
        title: 'Experience the Thrill of the Magic Square Community on Zealy',
        description:
          "Dive into the Magic Square Community on Zealy, an innovative platform that serves acclaimed blockchain games, metaverses, digital asset marketplaces, DeFi protocols, and even renowned web2 companies. Zealy's mission aligns perfectly with ours: to onboard, entertain, educate, and grow communities in a scalable manner.",
      },
      {
        bannerUrl: 'stories/4/story_banner_url_3.jpg',
        title: 'Why Should You Join the Adventure?',
        description:
          "The Magic Square Community on Zealy is not just about being part of a community; it's about being rewarded for your support. As we traverse from our Public Beta towards the launch of the $SQR Token, we have designed a gargantuan 1,000,000 $SQR token prize pool to be distributed after the token launch. That's not all! Until the token launch, we'll also be hosting \"sprints\" where you can win other exciting rewards like $USDT, NFTs, and exclusive prizes!",
      },
      {
        bannerUrl: 'stories/4/story_banner_url_4.jpg',
        title: 'How Zealy Adds to the Thrill',
        description:
          "On Zealy, you're rewarded for your quests. Completing each quest grants you XP Points. The more XP Points you accumulate, the higher your community rank. Some quests might need you to attain a certain rank to access them, ensuring you grow and evolve with us. And the best part? We're continually adding new quests!",
      },
      {
        bannerUrl: 'stories/4/story_banner_url_5.jpg',
        title: 'Understanding the Rewards Distribution',
        description:
          'Rewards for sprints will be distributed monthly, and the $SQR Tokens will be handed out after the token launch, expected in Q4 2023 (subject to market conditions). Once launched, the $SQR Tokens will be released through a vesting mechanism, ensuring a fair distribution of rewards amongst our community members.',
      },
      {
        bannerUrl: 'stories/4/story_banner_url_6.jpg',
        title: 'Embarking on the Quest',
        description:
          'This quest-filled adventure is a fantastic opportunity to join an engaging community, compete with fellow enthusiasts, and potentially win spectacular prizes. So, what are you waiting for? Take the leap, join our growing community on Zealy today, and start your thrilling quest with Magic Square. Remember, your growth and support fuel our journey. See you on Zealy!\n<a <a href="https://zealy.io/c/magicsquare/questboard" target="_blank" rel=" noopener noreferrer">Join the Magic Square Community on Zealy Now!</a>',
      },
    ],
  },
};
